import Vue from 'vue';
import {
  Header,
  Aside,
  Container,
  Main,
  Footer,
  Scrollbar,
  Menu,
  Submenu,
  MenuItem,
  Button,
  Tooltip,
  Notification,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Input,
  InputNumber,
  Form,
  FormItem,
  Breadcrumb,
  BreadcrumbItem,
  MessageBox,
  Message,
  Dialog,
  Divider,
  Select,
  Option,
  OptionGroup,
  Avatar,
  Table,
  TableColumn,
  Image,
  Pagination,
  Loading,
  Popover,
  DatePicker,
  Switch,
  Row,
  Col,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Link,
  Radio,
  RadioGroup,
  RadioButton,
  Badge,
  Tag,
  Timeline,
  TimelineItem,
  Upload,
  Backtop,
  Icon,
  Cascader,
  drawer,
  Tabs,
  TabPane,
  autocomplete,
} from 'element-ui';

Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Scrollbar);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Button);
Vue.use(Tooltip);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);
Vue.use(Dialog);
Vue.use(Divider);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Avatar);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Image);
Vue.use(Pagination);
Vue.use(Loading);
Vue.use(Popover);
Vue.use(DatePicker);
Vue.use(Switch);
Vue.use(Row);
Vue.use(Col);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Link);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Badge);
Vue.use(Tag);
Vue.use(Timeline);
Vue.use(TimelineItem);
Vue.use(Upload);
Vue.use(Backtop);
Vue.use(Icon);
Vue.use(Cascader);
Vue.use(drawer);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(autocomplete);

Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
